import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexLeaflet',
  setup(__props) {

let Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const SimpleMap = defineAsyncComponent(() => import("@/components/theme/maps/SimpleMap.vue"))
const MultiLanguage = defineAsyncComponent(() => import("@/components/theme/maps/MultiLanguage.vue"))
const MultiLanguage2 = defineAsyncComponent(() => import("@/components/theme/maps/MultiLanguage2.vue"))
let desc = ref<string>("Display a map with labels in a foreign language")

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Map",
      mains: "Vue Leaflet",
      title: "Vue Leaflet"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card3), {
          colClass: "col-xl-6",
          cardhaderClass: "card-no-border pb-0",
          title: "Simple Map",
          headerTitle: "true"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SimpleMap))
          ]),
          _: 1
        }),
        _createVNode(_unref(Card3), {
          colClass: "col-xl-6",
          cardhaderClass: "card-no-border pb-0",
          pre: "true",
          preClass: "mt-1 mb-0",
          title: "Multi-language support",
          headerTitle: "true",
          desc: "Display a map with labels in a foreign language"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MultiLanguage))
          ]),
          _: 1
        }),
        _createVNode(_unref(Card3), {
          colClass: "col-xl-12",
          cardhaderClass: "card-no-border pb-0",
          pre: "true",
          preClass: "mt-1 mb-0",
          title: "Map With Marker",
          headerTitle: "true",
          desc: "Display a map with labels in a foreign language"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MultiLanguage2))
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})